export const dashboardStyles = {
  section: "w-full py-12 md:py-13 px-4", 
  headerContainer: "border-l-[6px] border-msc-green pl-6 md:pl-8 mb-8 md:mb-12",
  headerTitle: "text-2xl md:text-4xl font-black text-msc-dark tracking-tight",
  headerSubtitle: "text-slate-400 text-[9px] md:text-[11px] mt-2 font-black uppercase tracking-[0.2em] opacity-80"
};